import React from 'react';

import { SVGComponentProps } from './svg.types';

const OnboardingObjectiveSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <rect
          x="0.6"
          y="1.1"
          width="46.8"
          height="46.8"
          rx="9"
          stroke="#E5E7EB"
          strokeWidth="1.2"
        />
        <rect x="4.80005" y="5.2998" width="38.4" height="38.4" rx="4.8" fill="#EBF1FF" />
        <path
          d="M29 14.9301H19C16 14.9301 14 16.9301 14 19.9301V25.9301C14 28.9301 16 30.9301 19 30.9301V33.0601C19 33.8601 19.89 34.3401 20.55 33.8901L25 30.9301H29C32 30.9301 34 28.9301 34 25.9301V19.9301C34 16.9301 32 14.9301 29 14.9301ZM24 27.1001C23.58 27.1001 23.25 26.7601 23.25 26.3501C23.25 25.9401 23.58 25.6001 24 25.6001C24.42 25.6001 24.75 25.9401 24.75 26.3501C24.75 26.7601 24.42 27.1001 24 27.1001ZM25.26 22.9501C24.87 23.2101 24.75 23.3801 24.75 23.6601V23.8701C24.75 24.2801 24.41 24.6201 24 24.6201C23.59 24.6201 23.25 24.2801 23.25 23.8701V23.6601C23.25 22.5001 24.1 21.9301 24.42 21.7101C24.79 21.4601 24.91 21.2901 24.91 21.0301C24.91 20.5301 24.5 20.1201 24 20.1201C23.5 20.1201 23.09 20.5301 23.09 21.0301C23.09 21.4401 22.75 21.7801 22.34 21.7801C21.93 21.7801 21.59 21.4401 21.59 21.0301C21.59 19.7001 22.67 18.6201 24 18.6201C25.33 18.6201 26.41 19.7001 26.41 21.0301C26.41 22.1701 25.57 22.7401 25.26 22.9501Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default OnboardingObjectiveSVG;
